<template>
  <div
    :class="classObj"
    :style="{
      height: connected ? '0px' : '30px',
      background: connected ? 'green' : '#e20f00',
    }"
  >
    {{ statusText }}
  </div>
</template>

<script>
export default {
  name: 'SocketError',
  data: () => ({
    connected: true,
  }),
  created() {
    this.$store.state.socket.on('disconnect', () => {
      this.connected = false;
    });

    this.$store.state.socket.on('connect', () => {
      this.connected = true;
    });
  },
  computed: {
    classObj() {
      return {
        'socket-error': true,
        online: this.connected,
        offline: !this.connected,
      };
    },
    statusText() {
      return this.connected ? 'Verbunden!' : 'Verbinde wieder...';
    },
  },
};
</script>

<style lang="scss">
.socket-error {
  transition: height 500ms;

  overflow: hidden;
  @include flex-center();
  font-weight: bold;

  &.online {
    transition: height 500ms, background 100ms;
  }
}
</style>
